import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { SectionHeader } from "../shared/SectionHeader";

export function FaqSection({ t }) {
  return (
    <section id="faq" className="relative py-24 md:py-32">
      <div className="container-x">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <SectionHeader eyebrow={t.faq.eyebrow} title={t.faq.title} />
              <p className="reveal mt-6 max-w-md text-base leading-relaxed text-muted-foreground md:text-lg">
                {t.faq.desc}
              </p>
            </div>
          </div>

          <div className="reveal lg:col-span-7">
            <Accordion
              type="single"
              collapsible
              className="overflow-hidden rounded-3xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] px-6 md:px-8"
            >
              {t.faq.items.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`faq-${index + 1}`}
                  className="border-[hsl(var(--border))] last:border-b-0"
                >
                  <AccordionTrigger className="gap-5 py-6 text-base hover:text-brand hover:no-underline md:text-lg">
                    <span className="flex items-baseline gap-4">
                      <span className="font-mono text-xs font-medium text-brand">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <span>{item.question}</span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 pl-10 pr-8 text-sm leading-relaxed text-muted-foreground md:text-base">
                    <div className="space-y-4">
                      {(Array.isArray(item.answer) ? item.answer : [item.answer]).map((paragraph, paragraphIndex) => (
                        <p key={paragraphIndex}>{paragraph}</p>
                      ))}

                      {item.bullets ? (
                        <ul className="list-disc space-y-2 pl-5">
                          {item.bullets.map((bullet, bulletIndex) => (
                            <li key={bulletIndex}>{bullet}</li>
                          ))}
                        </ul>
                      ) : null}

                      {item.cta ? (
                        <a
                          href={item.cta.href}
                          className="inline-flex font-medium text-brand underline decoration-brand/30 underline-offset-4 transition-colors hover:decoration-brand"
                        >
                          {item.cta.label}
                        </a>
                      ) : null}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
